<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.429 14.583"
    aria-hidden="true"
  >
    <path
      id="Path_67"
      data-name="Path 67"
      d="M14.935,31.292,9,35.866V26.718Zm7.558,0,5.935,4.574V26.718Zm-.867.67-2.654,2.045a.416.416,0,0,1-.517,0L15.8,31.962,9.393,36.9l-.372.286a1.519,1.519,0,0,0,1.4,1.4H27.008a1.517,1.517,0,0,0,1.4-1.4l-.374-.286-6.407-4.939Zm-2.912.9,9.319-7.182.374-.286a1.517,1.517,0,0,0-1.4-1.4H10.422a1.519,1.519,0,0,0-1.4,1.4l.372.286Z"
      transform="translate(-9 -24)"
      fill="currentColor"
    />
  </svg>
</template>
